export default '0.5.1';



// WEBPACK FOOTER //
// ./node_modules/moment-timezone/src/moment/version.js